module.exports = "<ng-container *ngIf=\"rate\">\r\n   <bar-rating [(rate)]=\"rate\" max=\"5\" readOnly=true></bar-rating>\r\n</ng-container>\r\n"